var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"load"}),_c('div',{staticClass:"lt"},[_vm._v(" 精彩加载中 ")]),_c('vue-loaders',{attrs:{"name":"ball-beat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }